import { PropsWithChildren } from 'react';
import EnvProvider from '../modules/EnvProvider';

import { DetermineMobileProvider } from '@myrealtrip/device-detect';
import QueryClientProvider from '../shared/components/QueryClientProvider';

import GlobalVariables from '../styles/GlobalVariables';

interface Props {
  targetEnv: string;
  defaultIsMobile?: boolean;
}

function LayoutProvider({ children, targetEnv, defaultIsMobile }: PropsWithChildren<Props>) {
  return (
    <EnvProvider targetEnv={targetEnv}>
      <DetermineMobileProvider defaultMobile={defaultIsMobile}>
        <GlobalVariables />
        <QueryClientProvider>{children}</QueryClientProvider>
      </DetermineMobileProvider>
    </EnvProvider>
  );
}

export default LayoutProvider;
